/* VCW homepage sections (vcw-home-*). Each section may include this file; it only runs once.
   Behaviour is bound per section root ([data-vh]) so the theme editor can re-render sections. */
(function () {
  if (window.VCWHome) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ICON = {
    pause: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg>',
    play: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>'
  };

  /* Add to bag, then hand over to the theme's cart drawer (same route as the vcw-pdp template). */
  function addToBag(items, btn, msg) {
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    if (msg) msg.textContent = '';
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Sorry, that couldn’t be added to your bag.');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'vcw-home' } }));
        if (typeof window.updateCartDrawer === 'function' && typeof window.openCartDrawer === 'function') {
          if (typeof window.closeAllDrawers === 'function') window.closeAllDrawers();
          window.updateCartDrawer();
          window.openCartDrawer();
        } else {
          location.href = root + 'cart';
        }
      })
      .catch(function (err) { if (msg) msg.textContent = err.message; })
      .finally(function () { if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); } });
  }

  /* Buy box: a form whose radios carry variant ids (Starter Box hero). */
  function initBuy(sec) {
    sec.querySelectorAll('[data-vh-buy]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = form.querySelector('input[name="vh-variant"]:checked') || form.querySelector('input[name="vh-variant"]');
        if (!v) return;
        addToBag([{ id: +v.value, quantity: 1 }], form.querySelector('[type="submit"]'), form.querySelector('.vh-msg'));
      });
    });
    /* Single-variant products: add directly. Multi-variant ones use the theme's .button-quick-add drawer. */
    sec.querySelectorAll('[data-vh-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        addToBag([{ id: +b.dataset.vhAdd, quantity: 1 }], b, sec.querySelector('[data-vh-msg="' + b.dataset.vhAdd + '"]'));
      });
    });
  }

  /* Carousel: autoplay unless reduced motion; pauses on hover and focus; pause button. */
  function initCarousel(sec) {
    var car = sec.querySelector('[data-vh-car]');
    if (!car) return;
    var slides = [].slice.call(car.querySelectorAll('.vh-slide'));
    var dots = car.querySelector('[data-vh-dots]'), tog = car.querySelector('[data-vh-toggle]');
    var cur = 0, hold = false, timer, every = (+car.dataset.speed || 6) * 1000;
    var playing = car.dataset.autoplay === 'true' && !reduce && slides.length > 1;
    if (dots) dots.innerHTML = slides.map(function (s, i) { return '<button type="button" aria-label="Show slide ' + (i + 1) + '"' + (i ? '' : ' aria-current="true"') + '></button>'; }).join('');
    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); s.inert = k !== cur; });
      if (dots) [].forEach.call(dots.children, function (d, k) { d.toggleAttribute('aria-current', k === cur); if (k === cur) d.setAttribute('aria-current', 'true'); });
    }
    function setTog() { if (!tog) return; tog.innerHTML = playing ? ICON.pause : ICON.play; tog.setAttribute('aria-label', playing ? 'Pause slides' : 'Play slides'); }
    function tick() { clearInterval(timer); if (playing) timer = setInterval(function () { if (!hold) show(cur + 1); }, every); }
    if (tog) tog.addEventListener('click', function () { playing = !playing; setTog(); tick(); });
    var prev = car.querySelector('[data-vh-prev]'), next = car.querySelector('[data-vh-next]');
    if (prev) prev.addEventListener('click', function () { show(cur - 1); });
    if (next) next.addEventListener('click', function () { show(cur + 1); });
    if (dots) [].forEach.call(dots.children, function (d, k) { d.addEventListener('click', function () { show(k); }); });
    car.addEventListener('mouseenter', function () { hold = true; });
    car.addEventListener('mouseleave', function () { hold = false; });
    car.addEventListener('focusin', function () { hold = true; });
    car.addEventListener('focusout', function () { hold = false; });
    show(0); setTog(); tick();
    sec._vhShow = function (el) { var i = slides.indexOf(el); if (i > -1) { playing = false; setTog(); tick(); show(i); } };
    sec._vhStop = function () { clearInterval(timer); };
  }

  /* Tabs (coffee rail, seasonal switcher): arrow keys, Home/End. */
  function initTabs(sec) {
    var tabs = [].slice.call(sec.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    function sel(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) t.focus();
      syncRails(sec);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { sel(t, true); });
      t.addEventListener('keydown', function (e) {
        var k = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
        if (k) { e.preventDefault(); sel(tabs[(i + k + tabs.length) % tabs.length], true); }
        else if (e.key === 'Home') { e.preventDefault(); sel(tabs[0], true); }
        else if (e.key === 'End') { e.preventDefault(); sel(tabs[tabs.length - 1], true); }
      });
    });
    sec._vhTab = function (blockEl) {
      var t = tabs.find(function (x) { return document.getElementById(x.getAttribute('aria-controls')) === blockEl || x === blockEl; });
      if (t) sel(t, false);
    };
  }

  function syncRails(sec) {
    sec.querySelectorAll('[data-vh-railwrap]').forEach(function (w) {
      if (w.closest('[hidden]')) return;
      var r = w.querySelector('.vh-rail'), p = w.querySelector('.vh-rail__btn--prev'), n = w.querySelector('.vh-rail__btn--next');
      if (!r || !p || !n) return;
      p.disabled = r.scrollLeft < 8;
      n.disabled = r.scrollLeft + r.clientWidth > r.scrollWidth - 8;
    });
  }
  function initRails(sec) {
    sec.querySelectorAll('[data-vh-railwrap]').forEach(function (w) {
      var r = w.querySelector('.vh-rail');
      if (!r) return;
      var by = function (d) { r.scrollBy({ left: d * r.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); };
      var p = w.querySelector('.vh-rail__btn--prev'), n = w.querySelector('.vh-rail__btn--next');
      if (p) p.addEventListener('click', function () { by(-1); });
      if (n) n.addEventListener('click', function () { by(1); });
      r.addEventListener('scroll', function () { syncRails(sec); }, { passive: true });
    });
    syncRails(sec);
  }

  /* Films play only while on screen, and never under reduced motion. */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
        if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else v.pause();
    });
  }, { rootMargin: '200px' }) : null;
  function initFilms(sec) { if (io) sec.querySelectorAll('video[data-vh-lazy]').forEach(function (v) { io.observe(v); }); }

  function init(sec) {
    if (!sec || sec._vhOn) return;
    sec._vhOn = true;
    initBuy(sec); initCarousel(sec); initTabs(sec); initRails(sec); initFilms(sec);
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-vh]').forEach(init); }

  window.VCWHome = { init: init, initAll: initAll, addToBag: addToBag };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  addEventListener('resize', function () { document.querySelectorAll('[data-vh]').forEach(syncRails); }, { passive: true });

  /* Theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    /* New quick-add buttons need the theme's binding; only buttons in this section are new. */
    if (typeof window.initialiseQuickAddButtons === 'function' && e.target.querySelector('.button-quick-add:not(.initialzed)')) {
      var others = [].slice.call(document.querySelectorAll('.button-quick-add.initialzed'));
      others.forEach(function (b) { b.classList.remove('button-quick-add'); });
      window.initialiseQuickAddButtons();
      others.forEach(function (b) { b.classList.add('button-quick-add'); });
    }
  });
  document.addEventListener('shopify:section:unload', function (e) { var s = e.target.querySelector('[data-vh]'); if (s && s._vhStop) s._vhStop(); });
  document.addEventListener('shopify:block:select', function (e) {
    var sec = e.target.closest('[data-vh]');
    if (!sec) return;
    if (sec._vhShow && e.target.classList.contains('vh-slide')) sec._vhShow(e.target);
    if (sec._vhTab) sec._vhTab(e.target);
  });
})();
